import { Link } from 'react-router-dom';
import BaseWrapper from '../components/BaseWrapper';
import styles from './Home.module.scss';

function Home() {
  return (
    <BaseWrapper>
      <div className={styles.hero}>
        <div className={styles.title}>FS Pilot</div>
        <div className={styles.subtitle}>A map utility tool for Microsoft Flight Simulator</div>
        <a className={styles.badge} href="https://play.google.com/store/apps/details?id=app.fspilot" target="_blank" rel="noreferrer">
          <img alt="Google Play Store Badge" src="Google_Play_Store_badge_EN.svg" />
        </a>
        <a className={styles.badge} href="https://apps.apple.com/app/fs-pilot-moving-map-for-msfs/id1560409041#?platform=iphone" target="_blank" rel="noreferrer">
          <img alt="Google Play Store Badge" src="App_Store_badge_EN.svg" />
        </a>
      </div>
      <h3>Server Application</h3>
      <p className={styles.downloadIntro}>To allow bidirectional communication between the sim and the FS Pilot mobile app, a tiny server app running in the background on the host PC is required.</p>
      <a className={styles.downloadButton} href="https://flightsim.to/file/10573/fs-pilot-world-map-and-flight-planner" target="_blank" rel="noreferrer">
        Download Server (1.97M)
      </a>
      <div className={styles.sourceCode}>
        <strong>Note: you might be warned that the software might not be safe. It's a false alarm.</strong>
        <br />
        You can read more about this issue on the official Go language website (in which the app is written){' '}
        <a href="https://golang.org/doc/faq#virus" target="_blank" rel="noreferrer">
          here
        </a>
        .
      </div>
      <h3>Installation Instructions</h3>
      <p>- The first time you connect, Windows Firewall will probably pop-up asking for your permission to create a connection. You must allow it.</p>
      <p>- Make sure your PC and mobile device are both connected to the same local network.</p>
      <p>- Enter given IP Address in the mobile app.</p>
      <p>- Run Microsoft Flight Simulator.</p>
      <br />
      <Link to="/support">Support</Link>{' '}
      <Link to="/privacy-policy">Privacy Policy</Link>
    </BaseWrapper>
  );
}

export default Home;
